import { INode, IPage } from '../Context/FormBuilderContext';

export function getNodesForPage(
  page: IPage | undefined,
  allNodes: INode[]
): INode[] {
  if (!page) return [];

  const nodeMap = new Map(allNodes.map(node => [node.id, node]));
  
  return page.nodeIds
    .map(id => nodeMap.get(id))
    .filter((node): node is INode => node !== undefined) || [];
}

export function getPageById(
  pageId: string | null | undefined,
  pages: IPage[]
): IPage | undefined {
  if (!pageId) return undefined;
  return pages.find(page => page.id === pageId);
}

export function canAddPage(pages: IPage[] | undefined, maxPages: number = 2): boolean {
  return (pages?.length || 0) < maxPages;
}

export function getNextPageNumber(pages: IPage[] | undefined): number {
  return (pages?.length || 0) + 1;
}



